import { useQuery } from '@tanstack/react-query';
import { getFrontendVersion } from 'API/version';
import axios from 'axios';
import { useEffect } from 'react';
import useUpdateAvailableStore from 'stores/update-available-store';
import { useUserData } from './use-user-data';

const useCheckFrontendVersion = () => {
  const { token } = useUserData();
  const setUpdateAvailable = useUpdateAvailableStore((state) => state.setUpdateAvailable);

  const { data: localVersion } = useQuery({
    queryKey: ['localVersion'],
    queryFn: async ({ signal }) => {
      const response = await axios.get('/dashboard/version.json', { signal });
      return response.data.commitHash ?? false;
    },
    staleTime: 2 * 60 * 1000,
    refetchInterval: 3 * 60 * 1000,
  });

  const { data: latestVersion } = useQuery({
    queryKey: ['latestVersion', token],
    queryFn: async ({ signal }) => {
      const response = await getFrontendVersion(signal);
      return response.commitHash ?? false;
    },
    enabled: !!token,
    staleTime: 2 * 60 * 1000,
    refetchInterval: 3 * 60 * 1000,
  });

  useEffect(() => {
    if (latestVersion && localVersion && latestVersion !== localVersion) {
      setUpdateAvailable(true);
    }
  }, [latestVersion, localVersion]);

  return {
    currentVersion: localVersion,
    latestVersion,
  };
};

export default useCheckFrontendVersion;
